export const BlockQuote = `<svg title="BlockQuote" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 19H3V5H4.5V19ZM17 8.5H7V7H17V8.5ZM7 17H17V15.5H7V17ZM20 12.75H7V11.25H20V12.75Z" fill="currentcolor"/>
</svg>`;